// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empsidebar-inline-1 {
  object-fit: contain;
  background: #fff;
}

.empsidebar-inline-2 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  color: rgba(239,68,68,.8);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  margin-top: 6px;
  font-family: inherit;
}

.empsidebar-inline-3 {
  object-fit: contain;
  background: #fff;
}

.empsidebar-inline-4 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  color: rgba(239,68,68,.8);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  margin-top: 6px;
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpSidebar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".empsidebar-inline-1 {\n  object-fit: contain;\n  background: #fff;\n}\n\n.empsidebar-inline-2 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  color: rgba(239,68,68,.8);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  width: 100%;\n  margin-top: 6px;\n  font-family: inherit;\n}\n\n.empsidebar-inline-3 {\n  object-fit: contain;\n  background: #fff;\n}\n\n.empsidebar-inline-4 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  color: rgba(239,68,68,.8);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  width: 100%;\n  margin-top: 6px;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
